import { render, staticRenderFns } from "./Vote_test.vue?vue&type=template&id=0ac64538&scoped=true&"
import script from "./Vote_test.vue?vue&type=script&lang=js&"
export * from "./Vote_test.vue?vue&type=script&lang=js&"
import style0 from "./Vote_test.vue?vue&type=style&index=0&id=0ac64538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac64538",
  null
  
)

export default component.exports